import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usersApi } from "@/app/lib/api/users";
import { userQueryKeys } from "../queries/useUserInformation";

interface UpdateSelectedCompanyParams {
  userId: string;
  companyId: string;
}

export function useUpdateSelectedCompany() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, companyId }: UpdateSelectedCompanyParams) => 
      usersApi.updateUserPreviouslySelectedCompany(userId, companyId),
    
    onSuccess: (_, variables) => {
      // Invalidate user information to refetch with updated previously_selected_company_id
      queryClient.invalidateQueries({ 
        queryKey: userQueryKeys.information(variables.userId) 
      });
    },
    
    onError: (error) => {
      console.error("Failed to update selected company:", error);
    },
  });
}